import { APIPaths } from "../api-config";
import BaseApi from "../base-api";

export class StoreNoticeApi extends BaseApi {
  async getNoticeList(
    parameters: APIPaths["/store-app/notice/list"]["get"]["parameters"]["query"],
  ): Promise<APIPaths["/store-app/notice/list"]["get"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.get("/store-app/notice/list", { params: parameters })).data;
  }

  async getUnconfirmedNoticeListAll(): Promise<
    APIPaths["/store-app/notice/unconfirmed/list-all"]["get"]["responses"]["200"]["content"]["application/json"]
  > {
    return (await this.get("/store-app/notice/unconfirmed/list-all")).data;
  }

  async putNoticeReadById(
    id: APIPaths["/store-app/notice/{id}/read"]["put"]["parameters"]["path"]["id"],
  ): Promise<APIPaths["/store-app/notice/{id}/read"]["put"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.put(`/store-app/notice/${encodeURIComponent(id)}/read`)).data;
  }

  async putNoticeConfirmById(
    id: APIPaths["/store-app/notice/{id}/confirm"]["put"]["parameters"]["path"]["id"],
    requestBody: APIPaths["/store-app/notice/{id}/confirm"]["put"]["requestBody"]["content"]["application/json"],
  ): Promise<APIPaths["/store-app/notice/{id}/confirm"]["put"]["responses"]["200"]["content"]["application/json"]> {
    return (await this.put(`/store-app/notice/${encodeURIComponent(id)}/confirm`, requestBody)).data;
  }
}
